import { z } from 'zod';

// ── Roles ──
export const roleEnum = z.enum([
  'gerente',
  'operaciones',
  'administrativo',
  'residente',
  'compras',
  'contabilidad',
]);
export type Role = z.infer<typeof roleEnum>;

// ── State Machines ──
export const projectStateEnum = z.enum([
  'contacto_inicial',
  'datos_listos',
  'proforma_generada',
  'proforma_en_revision',
  'proforma_aprobada',
  'en_ejecucion',
  'pre_liquidacion',
  'finalizado',
  'cancelado',
]);
export type ProjectState = z.infer<typeof projectStateEnum>;

export const proformaStateEnum = z.enum([
  'borrador',
  'enviada',
  'enviado_al_cliente',
  'aprobada',
  'rechazada',
]);
export type ProformaState = z.infer<typeof proformaStateEnum>;

export const planillaStateEnum = z.enum([
  'borrador',
  'pendiente_compras',
  'pendiente_administrativo',
  'correccion_solicitada',
  'revisada',
  'aprobada',
  'pagada',
]);
export type PlanillaState = z.infer<typeof planillaStateEnum>;

export const otStateEnum = z.enum([
  'pendiente',
  'en_progreso',
  'completada',
  'liquidada',
]);
export type OtState = z.infer<typeof otStateEnum>;

export const pedidoStateEnum = z.enum([
  'pendiente',
  'despachado_parcial',
  'despachado_total',
  'cancelado',
]);
export type PedidoState = z.infer<typeof pedidoStateEnum>;

export const preliquidacionStateEnum = z.enum(['borrador', 'completada']);
export type PreliquidacionState = z.infer<typeof preliquidacionStateEnum>;

export const liquidacionStateEnum = z.enum(['borrador', 'aprobada']);
export type LiquidacionState = z.infer<typeof liquidacionStateEnum>;

// ── Category Enums ──
export const rubroTipoEnum = z.enum(['gypsum', 'pintura', 'impermeabilizacion', 'empaste', 'general']);
export type RubroTipo = z.infer<typeof rubroTipoEnum>;

export const unidadEnum = z.enum(['m2', 'ml', 'unid', 'kg', 'glb']);
export type Unidad = z.infer<typeof unidadEnum>;

export const unidadMaterialEnum = z.enum([
  'm2', 'ml', 'unid', 'kg', 'glb', 'lt', 'gal', 'rollo', 'funda', 'plancha',
]);
export type UnidadMaterial = z.infer<typeof unidadMaterialEnum>;

export const categoriaEnum = z.enum(['gypsum', 'pintura', 'impermeabilizacion', 'empaste', 'general', 'mdo']);
export type Categoria = z.infer<typeof categoriaEnum>;

export const descuentoTipoEnum = z.enum(['multa', 'herramienta', 'anticipo_maestro', 'otro', 'administrativo']);
export type DescuentoTipo = z.infer<typeof descuentoTipoEnum>;

export const extraCategoriaEnum = z.enum(['gypsum', 'pintura', 'varios', 'varios_maestro']);
export type ExtraCategoria = z.infer<typeof extraCategoriaEnum>;

export const equipoMovimientoTipoEnum = z.enum(['salida', 'devolucion', 'ingreso', 'baja']);
export type EquipoMovimientoTipo = z.infer<typeof equipoMovimientoTipoEnum>;

export const pedidoTipoEnum = z.enum(['materiales', 'equipos', 'ambos']);
export type PedidoTipo = z.infer<typeof pedidoTipoEnum>;

export const gastoAdicionalCategoriaEnum = z.enum(['transporte', 'materiales_extra', 'otros']);
export type GastoAdicionalCategoria = z.infer<typeof gastoAdicionalCategoriaEnum>;

export const reingresoCategoriaEnum = z.enum(['devolucion', 'cobro_extra', 'otros']);
export type ReingresoCategoriaEnum = z.infer<typeof reingresoCategoriaEnum>;

export const documentTipoEnum = z.enum([
  'ot_pdf',
  'ot_xlsx',
  'reporte_planillas_pdf',
  'reporte_planillas_xlsx',
  'archivo_bancario',
  'reporte_avance_pdf',
  'reporte_fotografico_pdf',
  'liquidacion_pdf',
  'guia_transporte_pdf',
]);
export type DocumentTipo = z.infer<typeof documentTipoEnum>;

export const auditActionEnum = z.enum(['INSERT', 'UPDATE', 'DELETE', 'APPROVE', 'UNLOCK']);
export type AuditAction = z.infer<typeof auditActionEnum>;
